'use client';
import React from 'react';
import { usePlayerControlsEvents } from '../../hooks/integration/use-player-controls-events';

interface Props {
  muxPlayerRef: React.RefObject<any>;
}

export const CastToggleButton: React.FC<Props> = ({ muxPlayerRef }) => {
  const { handleToggle, isOn, isSupported } = usePlayerControlsEvents({
    mode: 'CHROMECAST',
    muxPlayerRef,
  });

  if (isSupported === false) return null;
  return (
    <button
      onClick={handleToggle}
      className="flex items-center justify-center px-3 py-2 rounded hover:bg-white/10"
      title={isOn ? 'Stop casting' : 'Start casting'}
    >
      {isOn ? (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
          <g>
            <path d="M1,18 L1,21 L4,21 C4,19.3 2.66,18 1,18 L1,18 Z"></path>
            <path d="M1,14 L1,16 C3.76,16 6,18.2 6,21 L8,21 C8,17.13 4.87,14 1,14 L1,14 Z"></path>
            <path d="M1,10 L1,12 C5.97,12 10,16.0 10,21 L12,21 C12,14.92 7.07,10 1,10 L1,10 Z"></path>
            <path d="M21,3 L3,3 C1.9,3 1,3.9 1,5 L1,8 L3,8 L3,5 L21,5 L21,19 L14,19 L14,21 L21,21 C22.1,21 23,20.1 23,19 L23,5 C23,3.9 22.1,3 21,3 L21,3 Z"></path>
            <path d="M5,7 L5,8.63 C8,8.6 13.37,14 13.37,17 L19,17 L19,7 Z"></path>
          </g>
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
          <g>
            <path d="M1,18 L1,21 L4,21 C4,19.3 2.66,18 1,18 L1,18 Z"></path>
            <path d="M1,14 L1,16 C3.76,16 6,18.2 6,21 L8,21 C8,17.13 4.87,14 1,14 L1,14 Z"></path>
            <path d="M1,10 L1,12 C5.97,12 10,16.0 10,21 L12,21 C12,14.92 7.07,10 1,10 L1,10 Z"></path>
            <path d="M21,3 L3,3 C1.9,3 1,3.9 1,5 L1,8 L3,8 L3,5 L21,5 L21,19 L14,19 L14,21 L21,21 C22.1,21 23,20.1 23,19 L23,5 C23,3.9 22.1,3 21,3 L21,3 Z"></path>
          </g>
        </svg>
      )}
    </button>
  );
};
